import { Dispatch, Action } from 'redux'
import { HeaderTwoTextMapDispatchReturnType } from './types/HeaderTwoTextMapDispatchReturnType'

export const HeaderTwoTextMapDispatch = (
  _dispatch: Dispatch<Action>
): HeaderTwoTextMapDispatchReturnType => {
  return {}
}
